// extracted by mini-css-extract-plugin
export default {"content":"prescriptionMemo_content__Qi7Pa","displayTitle":"prescriptionMemo_displayTitle__S2EoV"};